function clearFieldErrors(form) {
    form.querySelectorAll('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
    form.querySelectorAll('[data-ajax-error="true"]').forEach((el) => el.remove());
}

function showFieldErrors(form, errors) {
    Object.keys(errors).forEach((field) => {
        const input = form.querySelector(`[name="${field}"]`);
        if (!input) {
            return;
        }

        input.classList.add('is-invalid');

        const feedback = document.createElement('span');
        feedback.className = 'invalid-feedback';
        feedback.setAttribute('role', 'alert');
        feedback.setAttribute('data-ajax-error', 'true');

        const strong = document.createElement('strong');
        strong.textContent = errors[field][0];
        feedback.appendChild(strong);

        input.insertAdjacentElement('afterend', feedback);
    });
}

function syncRegisterFullNameField(form) {
    const firstNameInput = form.querySelector('#register_first_name');
    const fullNameInput = form.querySelector('#register_full_name');

    if (firstNameInput && fullNameInput) {
        fullNameInput.value = firstNameInput.value.trim();
    }
}

function submitAuthFormAjax(form, { onFailureReason, beforeSubmit } = {}) {
    function handleSubmit(event) {
        event.preventDefault();

        if (typeof beforeSubmit === 'function') {
            beforeSubmit();
        }

        clearFieldErrors(form);

        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = true;
        }

        function fallbackToNativeSubmit() {
            form.removeEventListener('submit', handleSubmit);
            form.submit();
        }

        fetch(form.action, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: new FormData(form),
        })
            .then((response) => {
                if (response.status === 422) {
                    return response.json().then((data) => {
                        showFieldErrors(form, data.errors || {});

                        if (data.failure_reason && onFailureReason) {
                            onFailureReason(data.failure_reason);
                        }

                        if (submitButton) {
                            submitButton.disabled = false;
                        }
                    });
                }

                if (response.ok) {
                    return response.json().then((data) => {
                        if (data && data.redirect) {
                            window.location.href = data.redirect;
                        } else {
                            fallbackToNativeSubmit();
                        }
                    });
                }

                fallbackToNativeSubmit();

                return null;
            })
            .catch(fallbackToNativeSubmit);
    }

    form.addEventListener('submit', handleSubmit);
}

export function initAuthModalAjaxForms() {
    const loginForm = document.getElementById('loginModalForm');
    if (loginForm) {
        submitAuthFormAjax(loginForm);
    }

    const registerForm = document.getElementById('registerModalForm');
    if (registerForm) {
        submitAuthFormAjax(registerForm, {
            beforeSubmit: () => syncRegisterFullNameField(registerForm),
            onFailureReason(failureReason) {
                if (window.MHTracking) {
                    window.MHTracking.registrationFailed({
                        entryPoint: sessionStorage.getItem('register.entry_point') || 'from_map',
                        authMethod: 'email',
                        failureReason,
                    });
                }
            },
        });
    }
}
